(function(){
  
  function fixQtyDisplay(root){
    // VISIBLE_QTY_GUARD: fix any quantity UI text that turns into [object Object]
    var nodes = (root||document).querySelectorAll('.qty, .quantity, [data-qty], [data-quantity], .js-qty__num, .js-qty__wrapper, .quantity__input');
    nodes.forEach(function(n){
      if(!n) return;
      // If it's an input, handled elsewhere
      if(n.tagName === 'INPUT') return;
      var txt = (n.textContent||'').trim();
      if(txt && !/^\d+$/.test(txt)){
        // Only correct if it contains obj/object junk
        if(txt.toLowerCase().indexOf('obj')>-1 || txt.toLowerCase().indexOf('object')>-1){
          n.textContent = '1';
        }
      }
    });
  }

function fixQty(root){
    var inputs = (root||document).querySelectorAll('input[name="quantity"], input.qty, input.quantity');
    inputs.forEach(function(inp){
      if(!inp || inp.dataset.qtyGuarded) return;
      inp.dataset.qtyGuarded = '1';
      var handler = function(){
        var v = String(inp.value);
        // allow digits only
        if(!/^\d+$/.test(v)){
          inp.value = '1';
        }
      };
      inp.addEventListener('input', handler);
      inp.addEventListener('change', handler);
      // run once
      handler();
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    fixQty(document);
    fixQtyDisplay(document);
    if(window.MutationObserver){
      var mo = new MutationObserver(function(muts){
        muts.forEach(function(m){
          if(m.addedNodes && m.addedNodes.length){
            m.addedNodes.forEach(function(n){
              if(n && n.querySelectorAll){ fixQty(n); fixQtyDisplay(n); }
            });
          }
        });
      });
      mo.observe(document.body, {childList:true, subtree:true});
    }
  });
})();
